import { useStore } from 'vuex'

type FlashPayload = {
  type: 'notice' | 'alert'
  message: string
}

export const useFlash = () => {
  const store = useStore()
  const updateFlash = (payload: FlashPayload) => store.dispatch('flash/updateFlash', payload, { root: true })

  return {
    updateFlash
  }
}
